var isObject = require('../internals/is-object');

module.exports = function (it) {
  if (!isObject(it)) {
    throw TypeError(String(it) + ' is not an object');
  } return it;
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/internals/an-object.js
// module id = 66
// module chunks = 0